import { api } from '@/services/api';

export default class FormModel {
	constructor(fields) {
		this.data = fields;

		this.populate(fields);
	}

	populate(fields) {
		for (const field in fields) {
			if (fields.hasOwnProperty(field)) {
				this[field] = fields[field];
			}
		}
	}

	getData() {
		let data = {};

		for (const field in this.data) {
			data[field] = this[field];
		}

		return data;
	}

	save(url) {
		if (!url) {
			throw 'Missing parameter: url';
		}

		let data = this.getData();

		if (data.id && !data.tokenHash) {
			return api.put(url, data);
		} else {
			return api.post(url, data);
		}
	}

	remove(url) {
		return api.delete(url);
	}
}